interface BenchCandidateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  candidateName: string;
}

export default function BenchCandidateModal({
  isOpen,
  onClose,
  onConfirm,
  candidateName
}: BenchCandidateModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-end">
      <button
        type="button"
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
        aria-label="Dismiss bench modal"
      />
      <div className="relative w-full rounded-t-3xl bg-white px-6 pb-6 pt-4 shadow-2xl">
        <div className="mx-auto h-1.5 w-12 rounded-full bg-gray-200 mb-6" />
        
        <div className="text-center mb-6">
          <h2 className="text-xl font-bold text-gray-900 mb-2">
            Bench Candidate?
          </h2>
          <p className="text-base text-gray-600">
            This will send <span className="font-semibold">{candidateName}</span> an invite to join our future talent pool.
          </p>
        </div>

        <div className="flex gap-3">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 h-12 rounded-xl border border-gray-300 text-gray-600 font-semibold hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex-1 h-12 rounded-xl bg-yellow-500 text-white font-bold hover:bg-yellow-600 transition-colors"
          >
            Confirm Bench
          </button>
        </div>
      </div>
    </div>
  );
}

